import { render, staticRenderFns } from "./WorkerAssignmentsApprove.vue?vue&type=template&id=aca52f82"
import script from "./WorkerAssignmentsApprove.vue?vue&type=script&lang=js"
export * from "./WorkerAssignmentsApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports